import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Link, useNavigate } from 'react-router-dom';

import { bem } from 'helpers/class-name';
import Button from 'components/Button';
import { SvgLeftArrow } from 'components/Svgs';
import { BackNavLinkContext } from './Contexts';

const { element } = bem('app__backnav-link');

const HistoryBackButton = () => {
  const navigate = useNavigate();

  function handleGoBack() {
    navigate(-1);
  }

  return (
    <Button onClick={handleGoBack} styled={false}>
      <SvgLeftArrow />
    </Button>
  );
};

const Element = ({ to, useHistoryHook }) => {
  if (!useHistoryHook) {
    return (
      <Link className={element()} to={to}>
        <SvgLeftArrow />
      </Link>
    );
  }

  return <HistoryBackButton />;
};

Element.propTypes = {
  to: PropTypes.string,
  useHistoryHook: PropTypes.bool,
};

const BackNavLink = ({ to, useHistoryHook }) => {
  return (
    <BackNavLinkContext.Consumer>
      {ref =>
        ref && ref.current
          ? ReactDOM.createPortal(<Element to={to} useHistoryHook={useHistoryHook} />, ref.current)
          : null
      }
    </BackNavLinkContext.Consumer>
  );
};

BackNavLink.propTypes = {
  to: PropTypes.string,
  useHistoryHook: PropTypes.bool,
};

export default BackNavLink;
